import {
  checkEParavoloAVathmias,
  checkEParavoloBVathmias,
  INITIAL_SUBMIT,
  REJECTED_FROM_CITIZEN,
  RESUBMITTED,
} from "../../../constants";

import { useHistory } from "react-router-dom";
import useLocale from "../../../hooks/useLocale";
import GovGrConfirmationMessage from "../../../components/GovGrConfirmationMessage";
import GovGrButton from "../../../components/GovGrButton";

const SuccessScreen = ({ protocolNumber, statusAppl }) => {
  const { t } = useLocale();
  const history = useHistory();

  const getStatusApplication = (status) => {
    // console.log(status);
    switch (status) {
      case INITIAL_SUBMIT:
        return true;
      case RESUBMITTED:
        return true;
      case checkEParavoloAVathmias:
        return true;
      case checkEParavoloBVathmias:
        return true;
      default:
        return false;
    }
  };

  return (
    <>
      {getStatusApplication(statusAppl) ? (
        <>
          <GovGrConfirmationMessage
            code={protocolNumber}
            title={t("Form submitted successfully")}
            body={t("Document code")}
          />
        </>
      ) : statusAppl === REJECTED_FROM_CITIZEN ? (
        <>
          <GovGrConfirmationMessage
            code={""}
            title={t("Your application has been cancelled!")}
            body={""}
          />
        </>
      ) : (
        <>
          <GovGrConfirmationMessage
            code={""}
            title={t(
              "Congratulations! Your application has been saved successfully!"
            )}
            body={""}
          />
        </>
      )}
      <GovGrButton
        variant="secondary"
        buttonText={t("Return")}
        onClick={() => history.push("/")}
      />
    </>
  );
};

export default SuccessScreen;
